import { getValueByPathKey } from "./get-value-by-path-key";
export function getRowKeyFromRecordKey(recordKey) {
    var getRowKey = null;
    if (typeof recordKey === "function") {
        getRowKey = recordKey;
    }
    else if (typeof recordKey === "string") {
        getRowKey = function (record) {
            var value = getValueByPathKey(record, recordKey);
            return typeof value === "undefined" || value === null
                ? ""
                : String(value);
        };
    }
    else {
        // 如果未提供 rowKey，使用索引生成
        // TODO: 输出告警
        getRowKey = function (_, recordIndex) { return "record_" + recordIndex; };
    }
    return getRowKey;
}
//# sourceMappingURL=get-row-key-from-record-key.js.map